import axiosInstance from "../helper/axiosIntanceApiZalo";
import axios from '../helper/axiosIntance';
import { normalizeStringInObject } from "../utils/normalize";

// function getFormData(object) {
//     const formData = new FormData();
//     if(object){
//         Object.keys(object).forEach(key => formData.append(key, object[key]));
//     }
//     return formData;
// }

//tien
const listTitle = (params) => {
    return axios.post('/team/api/listTitle', normalizeStringInObject(params));
}
const listDepartment = (params) => {
    return axios.post('/team/api/listDepartment', normalizeStringInObject(params))
}
const listRole = (params) => {
    return axios.post('/team/api/listRole', normalizeStringInObject(params))
}
//ADD
const addDepartment = (params) => {
    return axios.post('/team/api/saveAddDepartment', normalizeStringInObject(params))
}
const addTitle = (params) => {
    return axios.post('/team/api/saveAddTitle', normalizeStringInObject(params))
}
const addRole = (params) => {
    return axios.post('/team/api/saveAddRole', normalizeStringInObject(params))
}
//EDIT
const editDepartment = (params) => {
    return axios.post('/team/api/saveEditDepartment', normalizeStringInObject(params))
}
const editTitle = (params) => {
    return axios.post(`/team/api/saveEditTitle`, normalizeStringInObject(params));
};
const editRole = (params) => {
    return axios.post(`/team/api/saveEditRole`, normalizeStringInObject(params));
};
//DELETE
const deleteDepartment = (params) => {
    return axios.post(`/team/api/saveDeleteDepartment`, normalizeStringInObject(params));
}
const deleteTitle = (params) => {
    return axios.post(`/team/api/saveDeleteTitle`, normalizeStringInObject(params));
}
const deleteRole = (params) => {
    return axios.post(`/team/api/saveDeleteRole`, normalizeStringInObject(params));
}

export default {
    listTitle,
    listDepartment,
    listRole,
    addRole,
    addTitle,
    addDepartment,
    editDepartment,
    editTitle,
    editRole,
    deleteTitle,
    deleteDepartment,
    deleteRole
}
